import { render } from "./ChangeHome.vue?vue&type=template&id=387fce94&scoped=true"
import script from "./ChangeHome.vue?vue&type=script&lang=js"
export * from "./ChangeHome.vue?vue&type=script&lang=js"

import "./ChangeHome.vue?vue&type=style&index=0&id=387fce94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387fce94"]])

export default __exports__